export enum BoxTemplateLabels {
    FileType = 'fileType',
    MarketId = 'marketId',
    IsHidden = 'isHidden',
    IsEdited = 'isEdited',
    IsVisibleToRetailer = 'isVisibleToRetailer',
    ClassifiedByRole = 'classifiedByRole',
}
